import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from 'pages/document/page/components/StyledComponents';

export const PolygonsRoot = styled('div', { label: 'PolygonsRoot' })(() => ({
  position: 'absolute',
  inset: 0,
  userSelect: 'none',
  zIndex: PAGE_Z_INDEX.POLYGONS,
}));

export const PolygonsCanvas = styled('canvas', { label: 'PolygonsCanvas' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.POLYGONS + 1,
  userSelect: 'none',
}));

export const PolygonsArea = styled('div', { label: 'PolygonsArea' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.POLYGONS + 2,
  userSelect: 'none',

  '&.is-drawing > *': {
    pointerEvents: 'none',
  },
}));
